import { useRef } from 'react';
import EventEmitter from 'events';
import { EVENT_EMITTER } from '@centra/ui-global-context';

/**
 * Хук возвращает класс для обработки событий в компонентах
 * При использовании EventEmitter важно чтобы всегда был один instance
 */
export const useEventEmitter = (): EventEmitter => {
  const emitter = useRef(EVENT_EMITTER);

  return emitter.current;
};
